const dropdownRoot: any = document.createElement('div')
dropdownRoot.id = 'dropdown-root'
dropdownRoot.style.zIndex = 150
dropdownRoot.style.top = '16px'
dropdownRoot.style.position = 'fixed'
document.body.appendChild(dropdownRoot)

export { dropdownRoot }
